import React from 'react'
import './footer.css'
import {BsFacebook, BsLinkedin, BsGithub, BsInstagram} from 'react-icons/bs'

const Footer = () => {
    return (
        <footer>
            <a href="#" className="footer__logo">Anastasiia Kubrak</a>
            
                <ul className="permalinks">
                    <li>
                        <a href="#">Home</a>
                    </li>
                    <li>
                        <a href="#about">About</a>
                    </li>
                    <li>
                        <a href="#services">Services</a>
                    </li>
                    <li>
                        <a href="#portfolio">Portfolio</a>
                    </li>
                    <li>
                        <a href="#contact">Contact</a>
                    </li>
                </ul>
            
                <div className="footer__socials">
                    <a href="https://www.instagram.com/kubrak_photos?igsh=NDhwNDI0dGEzYTFo&utm_source=qr" target='_blank'><BsInstagram/></a>
                </div>
            <div className="footer__copyright">
                <small>&copy; Anastasiia Kubrak. All rights reserved.</small>
            </div>
        </footer>
    )
}
export default Footer
